import { useSelector } from 'react-redux';
import { captureEvent } from '../../../../services/event-capture';
import { appendInvitationParam } from '../../../../services/member/sharing';
import { nativeShare } from '../../../../services/share';
import { selectCurrentMemberId } from '../../../../services/store/modules/backend-service';
import {
  checkSocialSharingPluginExists,
  getRawURLFromPath,
} from '../../../helpers/share-helpers';

interface ShareConfig {
  sharePath: string;
  title: string;
  description: string;
  eventName: string;
  appendInvite?: boolean;
}

type NativeShareResponse = [boolean, (shareConfig: ShareConfig) => void];

const useNativeShare = (): NativeShareResponse => {
  const memberId = useSelector(selectCurrentMemberId);

  const triggerShare = (shareConfig: ShareConfig) => {
    captureEvent({
      type: shareConfig.eventName,
      payload: {},
      sendToAmplitude: true,
    });

    const { description, appendInvite, title } = shareConfig;

    // Build URL
    let path = getRawURLFromPath(shareConfig.sharePath);

    // Add invitation to the URL if required
    path =
      appendInvite && memberId ? appendInvitationParam(path, memberId) : path;

    // Note sure why we need this plugin, but it was using it previously
    if (checkSocialSharingPluginExists()) {
      try {
        nativeShare(title, path);
      } catch {
        // TODO: we want to know when it fails to show an error to the user.
      }
    } else if (navigator && navigator.share) {
      navigator.share({
        url: path,
        text: description,
        title,
      });
    } else {
      // oxlint-disable-next-line no-console -- legacy code. should use centralised logging instead
      console.warn('no sharing available');
    }
  };

  const canShare =
    checkSocialSharingPluginExists() || !!(navigator && navigator.share);
  return [canShare, triggerShare];
};

export default useNativeShare;
